
import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface WarningMessageProps {
  issuesDetected: number;
}

export const WarningMessage = ({ issuesDetected }: WarningMessageProps) => {
  if (issuesDetected <= 0) return null;
  
  return (
    <div className="p-4 bg-amber-50 dark:bg-amber-900/10 border-t border-amber-200 dark:border-amber-900/20">
      <div className="flex items-start">
        <AlertTriangle className="h-5 w-5 text-amber-500 mr-2 flex-shrink-0 mt-0.5" />
        <div>
          <h4 className="text-sm font-medium text-amber-800 dark:text-amber-300">
            Attention Required
          </h4>
          <p className="mt-1 text-xs text-amber-700 dark:text-amber-400">
            {issuesDetected} issues were detected that could not be automatically resolved. 
            Manual review is recommended for optimal compliance.
          </p>
        </div>
      </div>
    </div>
  );
};
